import FullscreenIcon from '@mui/icons-material/Fullscreen';
import * as React from 'react';
import { useAppContext } from '../../contexts/AppContext';
import { FullScreenButton, FullScreenNotify, Root } from './styled';

import TapMenu from './tapMenu';
import { GameMinimalProps, GameProps } from '../../types';

export interface FrameProps {
  width: string;
  height: string;
  iframeRef?: React.RefObject<HTMLIFrameElement>;
  elementWidth: number | string;
  elementHeight: number | string;
  src: string;
}

export const Frame = React.forwardRef<HTMLIFrameElement, FrameProps>((props: FrameProps) => {
  const { width, height, elementWidth, elementHeight, src, iframeRef } = props;
  // const [fullScreen, setFullScreen] = React.useState(false);
  const [clickIframe, setClickIframe] = React.useState(false);
  const appContext = useAppContext();
  const { componentOptions } = appContext.useConfig();
  const { fullScreen, onHandleFullScreen: setFullScreen } = appContext.useFullscreen();

  const handleFullScreen = async () => {
    setFullScreen((prevState: boolean) => !prevState)
    // Must show user if game is paused or not
    setClickIframe(true)
    setTimeout(() => setClickIframe(false), 3000)
  }

  React.useEffect(() => {
    const keyDownHandler = (event: any) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        setFullScreen(false)
      }
    };

    document.addEventListener('keydown', keyDownHandler);

    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, []);

  return (
    <>
      {componentOptions?.component_fullscreen_button_is_visible && (
        <>
          <FullScreenNotify style={{ opacity: clickIframe ? '0.7' : '0' }}>
            Click if you want the game to continue!
          </FullScreenNotify>

          <FullScreenButton
            onClick={handleFullScreen}
            style={{
              position: !fullScreen ? 'absolute' : 'fixed',
            }}
          >
            <FullscreenIcon />
          </FullScreenButton>
        </>
      )}
      <Root
        ref={iframeRef}
        title="game"
        name="game"
        src={src}
        allow="fullscreen"
        sandbox="allow-scripts allow-orientation-lock allow-same-origin allow-popups"
        aria-label="game"
        scrolling="no"
        width={elementWidth}
        height={elementHeight}
        style={{
          width,
          height,
          position: !fullScreen ? 'absolute' : 'fixed',
          zIndex: !fullScreen ? 'inherit' : '10',
          marginTop: fullScreen ? '40px': '0px'
        }}
      />
      <TapMenu />
    </>
  );
});